import React from 'react';
import PropTypes from 'prop-types';
import metadata from 'libphonenumber-js/metadata.full.json';
import {
    parseIncompletePhoneNumber,
    formatIncompletePhoneNumber,
} from 'libphonenumber-js/max';
import CountryOptions from '@/common/country-options';

const base_classname = 'm2g-phone-number-input';

const PhoneNumberInputWithValidation = React.forwardRef(
    (
        {
            value,
            country,
            placeholder,
            error,
            containerClassName,
            className,
            disabled,
            containerRef,
            errorRef,
            onChange,
            onCountryChange,
            onClick,
            onKeyUp,
            onBlur,
        },
        ref
    ) => {
        const format = phone_number =>
            formatIncompletePhoneNumber(phone_number, country, metadata);

        const onInputChange = event => {
            let new_value = parseIncompletePhoneNumber(event.target.value);
            if (new_value === value) {
                if (format(new_value).indexOf(event.target.value) === 0) {
                    // Trim the last digit (or plus sign).
                    new_value = new_value.slice(0, -1);
                }
            }
            onChange(new_value);
        };

        const onCountryInputChange = event => {
            onCountryChange(event.target.value);
        };

        return (
            <div
                data-phone-number
                data-icon-before
                className={`${containerClassName} ${base_classname} m2g-input-container`}
                onClick={onClick}
                role="presentation"
                ref={containerRef}
            >
                <input
                    type="tel"
                    className={`${className} m2g-input ${
                        error ? 'm2g-input--error' : ''
                    }`}
                    placeholder={placeholder}
                    value={format(value)}
                    onChange={onInputChange}
                    onKeyUp={onKeyUp}
                    onBlur={onBlur}
                    ref={ref}
                />
                <span className="m2g-icon m2g-icon--phone" />
                <div className={`${base_classname}-country`}>
                    <span className={`${base_classname}-country-alpha2`}>
                        {country}
                    </span>
                    {!disabled && (
                        <>
                            <select
                                className={`${base_classname}-country-select`}
                                value={country}
                                onChange={onCountryInputChange}
                            >
                                <CountryOptions />
                            </select>
                            <div className="m2g-icon m2g-icon--chevron-down" />
                        </>
                    )}
                </div>
                {error && (
                    <div
                        className={`${base_classname}-error m2g-text--small m2g-text--offset`}
                        ref={errorRef}
                    >
                        {error}
                    </div>
                )}
            </div>
        );
    }
);

PhoneNumberInputWithValidation.propTypes = {
    value: PropTypes.string.isRequired,
    country: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    error: PropTypes.string,
    containerClassName: PropTypes.string,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    containerRef: PropTypes.func,
    errorRef: PropTypes.func,
    onChange: PropTypes.func,
    onCountryChange: PropTypes.func,
    onClick: PropTypes.func,
    onKeyUp: PropTypes.func,
    onBlur: PropTypes.func,
};

PhoneNumberInputWithValidation.defaultProps = {
    placeholder: '',
    error: '',
    containerClassName: '',
    className: '',
    disabled: false,
    containerRef: undefined,
    errorRef: undefined,
    onChange: () => {},
    onCountryChange: () => {},
    onClick: undefined,
    onKeyUp: undefined,
    onBlur: undefined,
};

export default PhoneNumberInputWithValidation;
